import React from 'react';
import { CheckCircle, LockKeyhole, Save } from 'lucide-react';
import { formatCurrency } from '../../utils/formatters.js';

const VehicleVisitFinalizationCard = ({
    visitId,
    expectedTotal,
    canManageFinalization,
    isEditing,
    hasItems,
    canFinalize,
    validationMessage = '',
    isSaving,
    onFinalize,
}) => {
    if (!canManageFinalization)
        return null;

    const needsItems = !hasItems;
    const needsSave = !needsItems && isEditing;
    const hasInvalidItems = !needsItems && !needsSave && Boolean(validationMessage);
    const ready = canFinalize && !isSaving;
    const guidance = needsItems
        ? 'أضف بندًا واحدًا على الأقل ثم احفظ الزيارة قبل الاعتماد.'
        : needsSave
            ? 'احفظ البنود أولًا، ثم اضغط اعتماد الإجمالي النهائي.'
            : hasInvalidItems
                ? `صحّح بنود الزيارة قبل الاعتماد: ${validationMessage}`
            : expectedTotal === 0
                ? 'إجمالي العميل صفر. تبقى تكلفة البنود لصالح الورشة أو لصالح المورد بحسب من يتحملها.'
                : 'راجع إجمالي العميل ثم اعتمده. البنود لصالح الورشة أو المورد لا تدخل في إجمالي العميل.';

    return (
        <section
            className="mb-4 liquid-surface"
            style={{
                borderRadius: 20,
                padding: 14,
                background: 'rgba(238,242,255,0.76)',
                border: '1px solid rgba(99,102,241,0.28)',
            }}
            data-testid={`visit-finalization-card-${visitId}`}
        >
            <div className="flex items-start justify-between gap-3">
                <div>
                    <div className="flex items-center gap-2 text-sm font-extrabold" style={{ color: 'rgba(49,46,129,0.96)' }}>
                        <CheckCircle size={18} /> اعتماد إجمالي الزيارة
                    </div>
                    <p className="mt-1 text-xs leading-5" style={{ color: 'rgba(67,56,202,0.88)' }} data-testid={`visit-finalization-guidance-${visitId}`}>
                        {guidance}
                    </p>
                </div>
                <div className="shrink-0 rounded-xl px-3 py-2 text-left" style={{ background: 'rgba(255,255,255,0.78)', border: '1px solid rgba(129,140,248,0.24)' }}>
                    <div className="text-[10px] font-semibold" style={{ color: 'rgba(99,102,241,0.92)' }}>إجمالي العميل</div>
                    <div className="mt-0.5 text-sm font-extrabold tabular-nums" style={{ color: 'rgba(49,46,129,0.96)' }} data-testid={`visit-finalization-total-${visitId}`}>
                        {formatCurrency(expectedTotal)}
                    </div>
                </div>
            </div>
            <button
                type="button"
                onClick={onFinalize}
                disabled={!ready}
                className="mt-3 min-h-11 w-full rounded-xl px-4 py-2 text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-55 disabled:cursor-not-allowed"
                style={{
                    background: ready ? 'linear-gradient(135deg, #4f46e5, #2563eb)' : 'rgba(148,163,184,0.35)',
                    color: ready ? '#fff' : 'rgba(71,85,105,0.9)',
                }}
                data-testid={`visit-finalize-button-${visitId}`}
            >
                {isSaving ? <Save size={16} className="animate-pulse" /> : ready ? <CheckCircle size={16} /> : <LockKeyhole size={16} />}
                {isSaving ? 'جاري الاعتماد...' : ready ? 'اعتماد الإجمالي النهائي' : needsItems ? 'أضف البنود واحفظها أولًا' : needsSave ? 'احفظ البنود أولًا' : hasInvalidItems ? 'صحّح البنود أولًا' : 'الاعتماد غير متاح'}
            </button>
        </section>
    );
};

export default VehicleVisitFinalizationCard;
